import DOMPurify from 'dompurify';

// Helper to check if content is effectively empty
export function isQuillContentEmpty(html) {
  const clean = DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).trim();
  return clean === '';
}

export function cleanQuillHtml(html) {
    if (!html) return html;

    let prev;
    let clean = html;

    do {
        prev = clean;
        clean = clean
            // remove Quill's zero-width cursor placeholder character
            .replace(/\uFEFF/g, '')
            // remove empty spans (e.g. <span class="ql-cursor"></span>)
            .replace(/<span[^>]*>(\s|&nbsp;)*<\/span>/gi, '')
            // remove <p> tags that only contain whitespace, &nbsp;, or <br> tags
            .replace(/<p[^>]*>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '')
            // remove empty <div> wrappers left behind the same way
            .replace(/<div[^>]*>(\s|&nbsp;|<br\s*\/?>)*<\/div>/gi, '');
    } while (clean !== prev);

    return clean
        .replace(/&nbsp;/g, ' ')
        .trim();
}

// export function cleanQuillHtml(html) {
//     if (!html) return "";

//     let prev;
//     let clean = html;

//     do {
//         prev = clean;

//         clean = clean
//             // Remove zero-width characters
//             .replace(/\uFEFF/g, "")

//             // Remove empty spans
//             .replace(/<span[^>]*>(\s|&nbsp;)*<\/span>/gi, "")

//             // Remove empty paragraphs
//             .replace(/<p[^>]*>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "")

//             // Remove empty divs
//             .replace(/<div[^>]*>(\s|&nbsp;|<br\s*\/?>)*<\/div>/gi, "")

//             // Remove duplicate whitespace between tags
//             .replace(/>\s+</g, "><");

//     } while (clean !== prev);

//     return clean
//         .replace(/&nbsp;/g, " ")
//         .trim();
// }